module.exports = __webpack_public_path__ + "img/HZ-P6004.e43fe957.jpg";